import { API_ENDPOINTS } from "./api-endpoints";
import { HttpClient } from "./http-client";

export const customerVerificationClient = { 

    addressLookup(postCode: any) {
        return HttpClient.get(`${API_ENDPOINTS.ADDRESS_LOOKHP}?postcode=${postCode}`);
    },
    checkCustomerKYC(data: any) {
        return HttpClient.post(API_ENDPOINTS.CHECK_CUSTOMER_KYC, data);
    },
    addCustomerDetails(data: any) {
        return HttpClient.post(API_ENDPOINTS.Add_UPDATE_CUSTOMER, data);
    },
    getCustomerDetails(data: any) {
        return HttpClient.post(API_ENDPOINTS.GET_CUSTOMER, data);
    },
    getCustomerInfo(data: any, token?: string) {
        return HttpClient.post(API_ENDPOINTS.GET_CUSTOMER_INFO, data, token ? { _urlToken: token } : undefined);
    },
    customerFraudcheck(data: any) {
        return HttpClient.post(API_ENDPOINTS.CUSTOMER_FRAUDCHECK, data);
    },
    deleteQuate(data: any) {
        return HttpClient.post(API_ENDPOINTS.DELETE_QUATE, data);
    }
}